import React from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
  NamedRedirect,
} from '../../components';
import config from '../../config';
import { articles } from '../../containers/SupportPage/articles';
import classNames from 'classnames';

import css from './PaymentSupportPage.module.css';

const PaymentSupportPageComponent = props => {
  const { intl, params } = props;
  const { siteTitle } = config;

  const headerTitle = intl.formatMessage({ id: 'PaymentSupportPage.headerTitle' });
  const supportLinkText = intl.formatMessage({ id: 'PaymentSupportPage.supportLinkText' });
  const currentPageText = intl.formatMessage({ id: 'PaymentSupportPage.currentPage' });

  const articleSlug = params.slug;
  const currentArticle = articles.payment.find(s => s.key === articleSlug);

  if (!currentArticle) {
    return <NamedRedirect name="SupportPage" />;
  }

  const { label, html } = currentArticle;
  return (
    <StaticPage
      title={`Support | ${siteTitle}`}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'PaymentSupportPage',
        description: 'Support',
        name: 'PaymentSupportPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <StaticPageHeader
            titleClassName={css.headerTitle}
            title={headerTitle}
            currentPage="SupportPage"
          />
          <div className={css.contentWrapper}>
            <div className={css.supportLinks}>
              <NamedLink className={css.supportLink} name="SupportPage">
                {supportLinkText}
              </NamedLink>
              <span className={css.linksSeparator}>/</span>
              <span className={css.currentLink}>{currentPageText}</span>
            </div>
            <div className={css.contentGrid}>
              <ul className={css.categoryArticles}>
                {articles.payment.map((a, index) => {
                  const articleIndex = index + 1;
                  const isActive = a.key === articleSlug;
                  return (
                    <li
                      className={classNames(css.categoryArticle, {
                        [css.categoryArticleActive]: isActive,
                      })}
                    >
                      <NamedLink
                        className={css.categoryArticleLink}
                        name="PaymentSupportPage"
                        params={{ slug: a.key }}
                      >
                        {`${articleIndex}. ${a.label}`}
                      </NamedLink>
                    </li>
                  );
                })}
              </ul>
              <div className={css.articleContent}>
                <h2 className={css.articleHeading}>{label}</h2>
                <div className={css.articleText}>{html}</div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

PaymentSupportPageComponent.propTypes = {
  intl: intlShape.isRequired,
};

const PaymentSupportPage = compose(injectIntl)(PaymentSupportPageComponent);

export default PaymentSupportPage;
